import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import * as kioskAPI from '../../lib/api/kiosk';
import { uploadImageToServer } from '../../lib/commonFunc/commonFunc';
import imageCompression from 'browser-image-compression';
import KioskSetting from '../../components/app/KioskSetting';

const KioskSettingContainer = ({ history }) => {
    const { club } = useSelector(({ club }) => ({
        club: club.defaultClub,
    }));

    const [title, setTitle] = useState('');
    const [titleSize, setTitleSize] = useState(150);
    const [memo, setMemo] = useState('');
    const [memoSize, setMemoSize] = useState(48);
    const [imageURL, setImageURL] = useState('');
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('123456');
    const [loading, setLoading] = useState(false);
    const [imageUploading, setImageUploading] = useState(false);

    useEffect(() => {
        if (!club || !club.clubID) return;
        loadKioskInfoData();
    }, [club]);

    const loadKioskInfoData = async () => {
        try {
            const res = await kioskAPI.loadKioskInfo({ clubID: club.clubID });
            if (res.data && res.data.info) {
                const info = res.data.info;
                setTitle(info.title || (club.name || ''));
                setTitleSize(info.titleSize || 150);
                setMemo(info.memo || '');
                setMemoSize(info.memoSize || 48);
                // imageURL이 전체 URL이면 그대로, 아니면 상대 경로로 처리
                setImageURL(info.imageURL || '');
                setPhone(info.phone || '');
                setPassword(info.password || '123456');
            } else {
                // 정보가 없는 경우 기본값 설정
                setTitle(club.name || '');
                setTitleSize(150);
                setMemo('');
                setMemoSize(48);
                setImageURL('');
                setPhone('');
                setPassword('123456');
            }
        } catch (error) {
            console.error('키오스크 정보 로드 오류:', error);
            // 에러 발생 시에도 기본값 설정
            if (club && club.name) {
                setTitle(club.name);
                setTitleSize(150);
                setMemo('');
                setMemoSize(48);
                setImageURL('');
                setPhone('');
                setPassword('123456');
            }
        }
    };

    const onUploadImage = async (file) => {
        if (!club || !club.clubID) return;
        
        setImageUploading(true);
        try {
            // 이미지 압축
            const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1920,
            };
            const compressedFile = await imageCompression(file, options);
            
            // 파일명 생성: clubID_kiosk_timestamp
            const timestamp = Date.now();
            const fileExtension = file.name.split('.').pop();
            const filename = `${club.clubID}_kiosk_${timestamp}.${fileExtension}`;
            
            // 이미지 업로드
            const result = await uploadImageToServer(
                compressedFile,
                filename,
                'clubdata/clubImage',
                compressedFile.type
            );
            
            if (result && result.data) {
                // 업로드된 이미지 URL 설정
                const uploadedImageURL = `clubImage/${filename}`;
                setImageURL(uploadedImageURL);
                alert('이미지가 업로드되었습니다.');
            } else {
                alert('이미지 업로드에 실패했습니다.');
            }
        } catch (error) {
            console.error('이미지 업로드 오류:', error);
            alert('이미지 업로드 중 오류가 발생했습니다.');
        } finally {
            setImageUploading(false);
        }
    };
    
    const onDeleteImage = () => {
        if (window.confirm('이미지를 삭제하시겠습니까?')) {
            setImageURL('');
        }
    };

    const onModifyKioskInfo = async () => {
        if (!club || !club.clubID) return;
        
        setLoading(true);
        try {
            const res = await kioskAPI.modifyKioskInfo({
                clubID: club.clubID,
                title,
                titleSize,
                memo,
                memoSize,
                imageURL,
                phone,
                password,
            });
            
            if (res.data && res.data.result === 1) {
                alert('키오스크 정보가 수정되었습니다.');
                loadKioskInfoData();
            } else {
                alert('키오스크 정보 수정에 실패했습니다.');
            }
        } catch (error) {
            console.error('키오스크 정보 수정 오류:', error);
            alert('키오스크 정보 수정 중 오류가 발생했습니다.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <KioskSetting
            title={title}
            setTitle={setTitle}
            titleSize={titleSize}
            setTitleSize={setTitleSize}
            memo={memo}
            setMemo={setMemo}
            memoSize={memoSize}
            setMemoSize={setMemoSize}
            imageURL={imageURL}
            setImageURL={setImageURL}
            phone={phone}
            setPhone={setPhone}
            password={password}
            setPassword={setPassword}
            onModifyKioskInfo={onModifyKioskInfo}
            onUploadImage={onUploadImage}
            onDeleteImage={onDeleteImage}
            imageUploading={imageUploading}
            loading={loading}
            clubID={club && club.clubID}
        />
    );
};

export default KioskSettingContainer;

